import React, { useRef, useState } from "react";
import "./StepDocuments.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import { setActiveSection } from "../../redux/actions/dashboardActions";

export default function StepDocuments() {

  const {token} = useSelector((state)=>state.auth);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({

    pieceIdentite: null,
    justificatifEntreprise: null,
    autorisationSpecifique: false,
    docAutorisation: null,
  });
  const fileInputRefs = {
    pieceIdentite: useRef(null),
    justificatifEntreprise: useRef(null),
    docAutorisation: useRef(null),
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, [field]: file })); // ⚡ on stocke le File directement
    }
  };


  const handleRemoveFile = (field) => {
    setFormData((prev) => ({ ...prev, [field]: null }));
    if (fileInputRefs[field].current) {
      fileInputRefs[field].current.value = "";
    }
  };

  const handleCheckboxChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      autorisationSpecifique: e.target.checked,
      docAutorisation: e.target.checked ? prev.docAutorisation : null,
    }));
  };

const handleSave = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const data = new FormData();
  data.append("pieceIdentite", formData.pieceIdentite);
  data.append("justificatifEntreprise", formData.justificatifEntreprise);

  if (formData.autorisationSpecifique && formData.docAutorisation) {
    data.append("docAutorisation", formData.docAutorisation);
  }

  try {
    const response = await fetch(`${apiUrl}/api/verif/verify`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || "Erreur lors de l’envoi");
    }

    alert("Documents envoyés avec succès, vous recevrez une notification lorsque votre profil sera validé");
    dispatch(fetchProfilPrestataire(token));
    dispatch(setActiveSection("projets"));
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};


  return (
    <>
      <h2 className="step-title">Documents de validation</h2>

      {/* Pièce d’identité */}
      <div className="doc-upload">
        <label>Pièce d’identité :</label>
        {!formData.pieceIdentite && (
          <input
            type="file"
            accept="image/*,application/pdf"
            ref={fileInputRefs.pieceIdentite}
            onChange={(e) => handleFileChange(e, "pieceIdentite")}
          />
        )}
        {formData.pieceIdentite && (
          <div className="doc-preview">
            <span>{formData.pieceIdentite.name}</span>
            <button
              type="button"
              className="btn-remove-doc"
              onClick={() => handleRemoveFile("pieceIdentite")}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        )}
      </div>

      {/* Justificatif entreprise */}
      <div className="doc-upload">
        <label>Justificatif d’entreprise :</label>
        {!formData.justificatifEntreprise && (
          <input
            type="file"
            accept="image/*,application/pdf"
            ref={fileInputRefs.justificatifEntreprise}
            onChange={(e) => handleFileChange(e, "justificatifEntreprise")}
          />
        )}
        {formData.justificatifEntreprise && (
          <div className="doc-preview">
            <span>{formData.justificatifEntreprise.name}</span>
            <button
              type="button"
              className="btn-remove-doc"
              onClick={() => handleRemoveFile("justificatifEntreprise")}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        )}
      </div>

      {/* Autorisation spécifique */}
      <div className="doc-upload">
        <label>
          <input
            type="checkbox"
            checked={formData.autorisationSpecifique}
            onChange={handleCheckboxChange}
          />
          Cette activité demande une autorisation spécifique
        </label>

        {formData.autorisationSpecifique && (
          <>
            {!formData.docAutorisation && (
              <input
                type="file"
                accept="image/*,application/pdf"
                ref={fileInputRefs.docAutorisation}
                onChange={(e) => handleFileChange(e, "docAutorisation")}
              />
            )}
            {formData.docAutorisation && (
              <div className="doc-preview">
                <span>{formData.docAutorisation.name}</span>
                <button
                  type="button"
                  className="btn-remove-doc"
                  onClick={() => handleRemoveFile("docAutorisation")}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <div className="inscriptionClientModal-actions">
        <button
          type="button"
          onClick={handleSave}
          disabled={!formData.pieceIdentite || !formData.justificatifEntreprise}
        >
          Verifier mon profil
        </button>
      </div>
    </>
  );
}
